import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.css']
})
export class MobileMenuComponent implements OnInit {
  @Input()
  show: boolean;
  @Output() getShowChange = new EventEmitter<boolean>();

  constructor() { }
  ngOnInit(): void {}
  
  close(): void {
    this.show = false;
    this.getShowChange.emit(false);
  }
}
